import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useNetworkStatus } from '@/stores/networkStatusStore';

/**
 * Connection Status Banner
 * Displays at the top of the page when network connection is lost
 * Auto-hides when connection is restored
 */
const ConnectionStatusBanner: React.FC = () => {
  const { isOffline } = useNetworkStatus();
  const [isVisible, setIsVisible] = useState(false);

  // Add slight delay before showing to avoid flashing on quick reconnects
  useEffect(() => {
    if (isOffline) {
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isOffline]);

  if (!isVisible) return null;

  const bannerStyle: React.CSSProperties = {
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'var(--warning-color)',
    color: 'var(--on-primary-color)',
    padding: '0.75rem 1rem',
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: '500',
    zIndex: 9999,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
  };

  return (
    <div style={bannerStyle} role="alert">
      <AlertTriangle size={20} aria-hidden="true" />
      <span>No internet connection. Please check your network and try again.</span>
    </div>
  );
};

export default ConnectionStatusBanner;
